import { useParams } from 'react-router-dom';
import { Loader, Page, PageTitleWithBack } from '../../../components';
import { ContractMangementEditor } from './ContractManagementEditor';
import { Alert, Box, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Save } from '@mui/icons-material';
import { useState } from 'react';
import { getSalesToolsContractDetails, updateDocumentFromPandaDocTemplate } from '../../../fetch';
import { useQuery } from 'react-query';

export const ContractManagementDetails = () => {
  const { pandaDocTemplateId, buildDocumentTypeId } = useParams<{
    buildDocumentTypeId: string;
    pandaDocTemplateId: string;
  }>();
  const { enqueueSnackbar } = useSnackbar();
  const [isUpdating, setIsUpdating] = useState(false);

  const { data: contractDetails, isLoading } = useQuery(
    ['getSalesToolsContractDetails', buildDocumentTypeId, pandaDocTemplateId],
    () => getSalesToolsContractDetails(buildDocumentTypeId, pandaDocTemplateId),
    {
      enabled: !!buildDocumentTypeId && !!pandaDocTemplateId
    }
  );

  return (
    <Page
      title="Edit Contract"
      customBreadcrumbPath="/sales/sales-tools/contract-management/edit-contract"
    >
      <Box display="flex" alignItems="center">
        <Box flex={1}>
          <PageTitleWithBack
            title="Edit Contract"
            backUrl="/sales/sales-tools/contract-management"
            backText="Back to Contract Management"
            additionalHeaderContent={
              contractDetails?.isActive &&
              !contractDetails.isDeletedInPandaDoc && (
                <Button
                  id="update-template"
                  startIcon={<Save />}
                  onClick={async () => {
                    try {
                      setIsUpdating(true);
                      await updateDocumentFromPandaDocTemplate(
                        buildDocumentTypeId,
                        pandaDocTemplateId
                      );
                      enqueueSnackbar('Template updated successfully', {
                        variant: 'success'
                      });
                    } catch (error: any) {
                      enqueueSnackbar(error?.Detail ?? 'Error updating template', {
                        variant: 'error'
                      });
                    } finally {
                      setIsUpdating(false);
                    }
                  }}
                  disabled={isUpdating}
                >
                  Save Template
                </Button>
              )
            }
          />
        </Box>
      </Box>
      {isLoading && <Loader position="centered" />}
      {!isLoading && (
        <>
          {contractDetails?.isDeletedInPandaDoc ? (
            <Alert severity="error">
              Template has been deleted in Pandadoc. Go back to select a different template.
            </Alert>
          ) : (
            <ContractMangementEditor
              pandaDocTemplateId={pandaDocTemplateId}
              buildDocumentTypeId={buildDocumentTypeId}
            />
          )}
        </>
      )}
    </Page>
  );
};
